"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.HeaderBadge = exports.HeaderText = exports.HeaderActions = exports.HeaderInputs = void 0;
// external
const react_router_dom_1 = require("react-router-dom");
const React = require("react");
// local
const Badge_1 = require("../../../../atoms/Badge");
const Button_1 = require("../../../../atoms/Button");
const CircularIcon_1 = require("../../../../atoms/CircularIcon");
const colors_1 = require("../../../../../../types/colors");
const standardSizes_1 = require("../../../../../../types/standardSizes");
// css
const styles = require("../../styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "baseSection");
const HeaderInputs = ({ children }) => (React.createElement("div", { className: css("header_inputs"), "data-test": "header-inputs" }, children));
exports.HeaderInputs = HeaderInputs;
const HeaderActions = ({ children }) => (React.createElement("div", { className: css("header_actions") }, React.Children.map(children, (child) => {
    return React.cloneElement(child, {
        onClick: typeof child.props.onClick === "function"
            ? (evt) => {
                // TODO: figure out why evt is undefined
                if (evt) {
                    evt.stopPropagation();
                }
                child.props.onClick();
            }
            : null,
        className: child.type === CircularIcon_1.CircularIcon ? css("header_actions_icon") : ""
    });
})));
exports.HeaderActions = HeaderActions;
const HeaderText = ({ children }) => (React.createElement("div", { className: css("header_text") },
    React.createElement("span", null, children)));
exports.HeaderText = HeaderText;
const HeaderBadge = ({ children }) => (React.createElement("div", { className: css("header_badge") },
    React.createElement("span", null, children)));
exports.HeaderBadge = HeaderBadge;
/**
 * Wrapper for main headings with optional actions
 */
const Header = ({ children, className = "", isActive = false, isSticky = false, actions = [], badge, label, onClick }) => {
    const getButton = (action) => {
        if (!action.label) {
            return null;
        }
        if (env.theme === "zam") {
            return (React.createElement("span", { "data-test": "action-button" },
                React.createElement(Button_1.Button, { size: standardSizes_1.TStandardSizes.Small, onClick: action.onClick, to: action.to }, action.label)));
        }
        if (action.to) {
            return (React.createElement(react_router_dom_1.NavLink, { "data-test": "action-anchor", onClick: action.onClick, to: action.to }, action.label));
        }
        return (React.createElement("a", { "data-test": "action-anchor", onClick: action.onClick }, action.label));
    };
    return (React.createElement("header", { "data-test": "header", className: css("header", {
            "-active": isActive,
            "-sticky": isSticky,
            className
        }), onClick: onClick || null },
        children,
        React.createElement("div", { className: css("header_decorations") },
            badge && (React.createElement("span", null,
                React.createElement(Badge_1.Badge, null, badge.toString()))),
            label && (React.createElement("span", null,
                React.createElement("label", null, label))),
            Array.isArray(actions) &&
                actions.map((action, i) => {
                    const onClick = (evt) => {
                        // TODO why is evt undefined?
                        if (evt) {
                            evt.stopPropagation();
                        }
                        if (typeof action.onClick === "function") {
                            action.onClick(evt);
                        }
                    };
                    return (React.createElement("span", { "data-test": `action-${i}`, key: "action-" + i },
                        action.icon ? (React.createElement("span", { "data-test": "action-icon" },
                            React.createElement(CircularIcon_1.CircularIcon, { to: action.to, className: css("header_actions_icon"), name: action.icon, onClick: action.disabled ? null : onClick, size: standardSizes_1.TStandardSizes.Small, variant: action.disabled
                                    ? colors_1.TColorVariants.Disabled
                                    : action.variant }))) : null,
                        getButton(Object.assign(Object.assign({}, action), { onClick }))));
                }))));
};
exports.Header = Header;
//# sourceMappingURL=index.js.map